<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.campaign" :label="filtersLabel.campaign" :error-messages="errors.collect('campaign')" data-vv-name="campaign" :data-vv-as="filtersLabel.campaign" v-validate="'param|max:12'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.description" :label="filtersLabel.description" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="filtersLabel.description" v-validate="'entry|max:128'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.enabled" :label="filtersLabel.enabled" item-text="label" item-value="value" data-vv-name="enabled" :data-vv-as="filtersLabel.enabled" :error-messages="errors.collect('enabled')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="booleanList" v-model="filters.allIntermediary" :label="filtersLabel.allIntermediary" item-text="label" item-value="value" data-vv-name="allIntermediary" :data-vv-as="filtersLabel.allIntermediary" :error-messages="errors.collect('allIntermediary')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.effDate" :label="filtersLabel.effDate" :data-vv-as="filtersLabel.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')"></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Campaign Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="campaign" :loading="loading" :no-data-text="noDataText">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.campaign }}</td>
              <td class="text-xs-right">{{ props.item.description }}</td>
              <td class="text-xs-right">{{ formatDateTime2(props.item.effDate) }}</td>
              <td class="text-xs-right">{{ formatDateTime2(props.item.expDate) }}</td>
              <td class="text-xs-right">{{ formatBoolean(props.item.enabled) }}</td>
              <td class="text-xs-right">{{ formatBoolean(props.item.allIntermediary) }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.createdDate) }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" query review @query="doQuery" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doNew">
            Add New Campaign
            <v-icon right>mdi-playlist-plus</v-icon>
          </v-btn>
          <v-btn color="secondary" @click="doExportCampaignDetails" v-if="false">
            Export Campaign Details
            <v-icon right>mdi-file-export</v-icon>
          </v-btn>
        </div>
        <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Campaign?
          <div class="title">{{deleteCampaign}}</div>
        </confirm>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import clone from 'clone'
import toDate from 'date-fns/toDate'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: 'Campaign Code', align: 'left', value: 'campaign' },
        { text: 'Campaign Description', align: 'right', value: 'description' },
        { text: 'Effective Date', align: 'right', value: 'effDate' },
        { text: 'Expiry Date', align: 'right', value: 'expDate' },
        { text: 'Enabled', align: 'right', value: 'enabled' },
        { text: 'All Intermediary', align: 'right', value: 'allIntermediary' },
        { text: 'Created Date', align: 'right', value: 'createdDate' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        campaign: null,
        description: null,
        effDate: null,
        enabled: null,
        allIntermediary: null
      },
      filtersLabel: {
        campaign: 'Campaign Code',
        description: 'Campaign Description',
        effDate: 'Effective Date',
        enabled: 'Enabled',
        allIntermediary: 'All Intermediary'
      },
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      promptRemove: false,
      selectedCampaign: undefined,
      deleteCampaign: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.promotionManagement.menu.campaignList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.effDate) {
            massageFilters.effDate = formatDisplayDateTime2(removeTime(massageFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((campaign) => {
                const convertCampaign = {
                  campaign: campaign.campaign,
                  description: campaign.description,
                  effDate: toDate(campaign.effDate),
                  expDate: toDate(campaign.expDate),
                  enabled: campaign.enabled,
                  allIntermediary: campaign.allIntermediary,
                  createdDate: toDate(campaign.createdDate)
                }
                this.items.push(convertCampaign)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doQuery(data) {
      if (data && data.item && data.item.campaign) {
        this.$router.push({ name: 'campaignQuery', params: { campaign: data.item.campaign } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.campaign) {
        this.$router.push({ name: 'campaignReview', params: { campaign: data.item.campaign } })
      }
    },
    doNew() {
      this.$router.push({ name: 'campaignReview', params: { campaign: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCampaign = data
        this.deleteCampaign = data.campaign + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.menu.campaignDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          campaign: this.selectedCampaign.campaign
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.campaign = null
      this.filters.description = null
      this.filters.effDate = null
      this.filters.enabled = null
      this.filters.allIntermediary = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async doExportCampaignDetails() {
      const apiURI = this.$store.state.adminUser.menu.exportUsrRoles
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.get(apiURI)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  created() {
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
